import { ReactComponent as FlagIcon } from "./svg/uk-flag.svg";
import "../flag-icon.scss";

export const UKFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
